module.exports = __webpack_public_path__ + "static/TiemposHeadline-Light-2e19b3b364b386b168ae7f4d1559213e.woff2";